import { useContext, useMemo } from 'react';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';
import { computeDefaultDepartmentGroup } from './departmentGroup';

export const useDepartmentGroupDefault = () => {
  const { user } = useContext(AuthenticationContext);
  const isCollectionsAdmin = useMemo(
    () => !!user?.modules?.some((m) => m.value === 'collections' && parseInt(m.tier, 10) > 2),
    [user],
  );
  const myGroups = useMemo(() => user?.department_groups ?? [], [user]);
  const defaultDepartmentGroup = useMemo(
    () => computeDefaultDepartmentGroup(isCollectionsAdmin, myGroups),
    [isCollectionsAdmin, myGroups],
  );
  const myGroupsLabel = useMemo(() => [...myGroups].sort().join(', '), [myGroups]);
  return { user, isCollectionsAdmin, myGroups, defaultDepartmentGroup, myGroupsLabel };
};
